<template>
  <div>
    <div class="first-container">
      <div class="top-container">
        <div class="left-container">
          <!-- <el-row>序列号</el-row> -->
          <div>
            <el-row style="margin: 20px 0px 20px 0px">
              <el-button type="primary" @click="takePhoto">拍照</el-button>
            </el-row>
          </div>
          <div class="video-container">
            <el-row>
              <video ref="videoElement" style="width: 100%" id="video"></video>
            </el-row>
          </div>
        </div>

        <div class="right-container">
          <div class="img-container">
            <div class="img-item-container">
              <div class="single-image" v-if="this.screenflag">正面</div>
              <div v-else style="height: 200px">
                <img
                  :src="this.screenData.url"
                  style="width: 100%; height: 100%"
                  @click="handleLarge(screenData.url, 1)"
                />
              </div>
              <el-select
                v-model="screenData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                @change="handleChange"
              >
                <el-option
                  v-for="item in screenOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="backflag">背面</div>
              <div v-else style="height: 200px">
                <img
                  :src="backData.url"
                  style="width: 100%; height: 100%"
                  @click="handleLarge(backData.url, 2)"
                />
              </div>
              <el-select
                v-model="backData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                @change="handleChangeBack"
              >
                <el-option
                  v-for="item in backOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="leftflag">左侧面</div>
              <div v-else style="height: 200px">
                <img
                  :src="leftData.url"
                  @click="handleLarge(leftData.url, 3)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="leftData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                @change="handleChangeLeft"
              >
                <el-option
                  v-for="item in screenOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="rightflag">右侧面</div>
              <div v-else style="height: 200px">
                <img
                  :src="rightData.url"
                  @click="handleLarge(rightData.url, 4)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="rightData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                @change="handleChangeRight"
              >
                <el-option
                  v-for="item in screenOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="topflag">上面</div>
              <div v-else style="height: 200px">
                <img
                  :src="topData.url"
                  @click="handleLarge(topData.url, 5)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="topData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                @change="handleChangeTop"
              >
                <el-option
                  v-for="item in screenOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="bottomflag">尾插面</div>
              <div v-else style="height: 200px">
                <img
                  :src="bottomData.url"
                  @click="handleLarge(bottomData.url, 6)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="bottomData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                @change="handleChangeBottom"
              >
                <el-option
                  v-for="item in screenOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="SNflag">序列号</div>
              <div v-else style="height: 200px">
                <img
                  :src="SNData.url"
                  @click="handleLarge(SNData.url, 7)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="this.SNData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                disabled
              >
                <el-option
                  v-for="item in SNoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="IMEIflag">IMEI码</div>
              <div v-else style="height: 200px">
                <img
                  :src="IMEIData.url"
                  @click="handleLarge(IMEIData.url, 8)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="this.IMEIData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                disabled
              >
                <el-option
                  v-for="item in IMEIoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
            <div class="img-item-container">
              <div class="single-image" v-if="batteryflag">电池容量</div>
              <div v-else style="height: 200px">
                <img
                  :src="batteryData.url"
                  @click="batteryData(IMEIData.url, 9)"
                  style="width: 100%; height: 100%"
                />
              </div>
              <el-select
                v-model="this.batteryData.picText"
                placeholder="请选择"
                style="margin-top: 10px"
                disabled
              >
                <el-option
                  v-for="item in batteryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="middle-container">
              <div class="print_container">
                  <div>
                    <h3>打印机初始化：</h3>
                    <p align='left' style="margin-top: 20px;">
                      打印服务状态：{{ !printSocketOpen ? "未" : "已" }}连接
                    </p>

                    <p style="margin-top: 20px;" align='left'>
                      <label>选择USB打印机:</label>
                      <select v-model="usbSelectPrinter" name="usbPrinters">
                      <option value="" disabled v-if="!Object.keys(usbPrinters).length">
                          请选择USB打印机
                      </option>
                      <option
                          v-for="(value, name) in usbPrinters"
                          :value="name"
                          :key="name"
                      >
                          {{ name }}: {{ value }}
                      </option>
                      </select>
                      <button class="getPrinters" @click="getPrinters()" type="button">
                        更新USB打印机列表
                      </button>
                    </p>
                    
                    <p style="margin-top: 20px;" align='left'>
                      打印机连接状态：USB打印机{{ !onlineUsbBool ? "未" : "已" }}连接
                        <button
                          @click="selectOnLineUsbPrinter()"
                          type="button"
                          >
                            连接USB打印机
                        </button>
                    </p>                   
                    
                    <p style="margin-top: 20px;" align='left'>
                      SDK初始化状态：{{ !initBool ? "未" : "已" }}初始化
                        <button @click="init()" type="button">
                          初始化SDK
                        </button>
                    </p>
                  </div>
                </div>
            </div> -->

      <div class="bottom-container">
        <div>
          <div>
            <h3>产品信息：</h3>
            <div style="padding: 12px 6px 0px 6px">
              <el-form
                ref="phoneForm"
                :rules="rules"
                :model="phoneForm"
                :label-width="formLabelWidth"
              >
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="手机品牌" prop="phoneBrand">
                      <el-select v-model="phoneForm.phoneBrand">
                        <el-option
                          v-for="(data, index) in Array.from(
                            new Set(this.phoneBrandList)
                          )"
                          :key="index"
                          :value="data"
                          :label="data"
                          class="input"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="手机型号" prop="phoneName">
                      <el-select
                        v-model="phoneForm.phoneName"
                        @change="queryPhoneColorList"
                      >
                        <el-option
                          v-for="(data, index) in Array.from(
                            new Set(this.phoneNameList)
                          )"
                          :key="index"
                          :value="data"
                          :label="data"
                          class="input"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否有锁：" prop="IsLock">
                      <el-radio-group v-model="phoneForm.IsLock">
                        <el-radio label="有锁"></el-radio>
                        <el-radio label="无锁"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="机器类型" prop="phoneType">
                      <el-select v-model="phoneForm.phoneType">
                        <el-option
                          v-for="(data, index) in phoneTypeList"
                          :key="index"
                          :value="data"
                          :label="data"
                          class="input"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="机器版本" prop="phoneVersion">
                      <el-select v-model="phoneForm.phoneVersion">
                        <el-option
                          v-for="(data, index) in phoneVersionList"
                          :key="index"
                          :value="data"
                          :label="data"
                          class="input"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="售后保障" prop="salesGuarantee">
                      <el-select v-model="phoneForm.salesGuarantee">
                        <el-option
                          v-for="(data, index) in phoneGuaranteeList"
                          :key="index"
                          :value="data"
                          :label="data"
                          class="input"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="序列号" prop="SNName">
                      <el-input
                        v-model="phoneForm.SNName"
                        style="width: 220px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="型号号码" prop="modelName">
                      <el-input
                        v-model="phoneForm.modelName"
                        style="width: 220px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="颜色" prop="phoneColor">
                      <el-select v-model="phoneForm.phoneColor">
                        <el-option
                          v-for="(data, index) in Array.from(
                            new Set(this.phoneColorList)
                          )"
                          :key="index"
                          :value="data"
                          :label="data"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="IMEI" prop="IMEIName">
                      <el-input
                        v-model="phoneForm.IMEIName"
                        style="width: 220px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="IMEI2" prop="IMEI2Name">
                      <el-input
                        v-model="phoneForm.IMEI2Name"
                        style="width: 220px"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="运行内存">
                      <el-select v-model="phoneForm.phoneRuningMemory">
                        <el-option
                          v-for="(data, index) in Array.from(
                            new Set(this.phoneRuningMemoryList)
                          )"
                          :key="index"
                          :value="data"
                          :label="data"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="内存" prop="phoneMemory">
                      <el-select v-model="phoneForm.phoneMemory">
                        <el-option
                          v-for="(data, index) in Array.from(
                            new Set(this.phoneMemoryList)
                          )"
                          :key="index"
                          :value="data"
                          :label="data"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="电池健康度"
                      prop="phoneElectricityList"
                    >
                      <el-input
                        v-model="phoneForm.phoneElectricityList"
                        style="width: 220px"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="成色" prop="phoneOld">
                      <el-select v-model="phoneForm.phoneOld">
                        <el-option
                          v-for="(data, index) in phoneOldList"
                          :key="index"
                          :value="data"
                          :label="data"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="屏电情况" prop="Tips">
                      <el-select v-model="phoneForm.Tips">
                        <el-option
                          v-for="(data, index) in TipsList"
                          :key="index"
                          :value="data"
                          :label="data"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="Supplier">
                      <el-select v-model="phoneForm.Supplier">
                        <el-option
                          v-for="(data, index) in SupplierList"
                          :key="index"
                          :value="data"
                          :label="data"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label='供应商名称' prop="Supplier">
                            <el-input v-model="phoneForm.Supplier" style="width: 220px;"></el-input>
                          </el-form-item> -->
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <el-row>
              <el-col :span="14" :offset="14">
                <!-- <el-button type="primary" @click="previewTest(textPrintData)">打印预览</el-button> -->
                <el-button type="primary" @click="print(textPrintData)"
                  >打印</el-button
                >
                <el-button type="primary" @click="submitData()">保存</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-dialog
          title="图片剪裁"
          :visible.sync="cropperVisible"
          append-to-body
          :close-on-click-modal="false"
          width="40%"
        >
          <div class="cropper-content">
            <div class="cropper" style="text-align: center">
              <vue-cropper
                ref="cropper"
                @ready="onCropperReady"
                :canMove="crooperoption.canMove"
                :autoCrop="crooperoption.autoCrop"
                :img="crooperoption.img"
                :autoCropWidth="crooperoption.autoCropWidth"
                :autoCropHeight="crooperoption.autoCropHeight"
              >
              </vue-cropper>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="rotateRight">旋 转</el-button>
            <el-button @click="cropperVisible = false">取 消</el-button>
            <el-button
              type="primary"
              @click="confirmPic()"
              :loading="cropperLoading"
              >确认</el-button
            >
            <!-- <el-button type="primary" @click="confirmPic()" :loading="cropperLoading">文字识别</el-button> -->
          </div>
        </el-dialog>
        <el-dialog
          title="打印预览"
          :visible.sync="printVisible"
          width="30%"
          :before-close="handleClose"
        >
          <div>
            <img
              :src="previewImg"
              style="height: 300px; width: 200px; border: solid 1px #ced4da"
            />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="printVisible = false">取 消</el-button>
            <el-button type="primary" @click="startPrintJobTest(textPrintData)"
              >打印并保存</el-button
            >
          </span>
        </el-dialog>
        <el-dialog
          title="入库"
          :visible.sync="warehousingVisible"
          width="50%"
          :before-close="handleClose"
        >
          <div>
            <el-input
              type="textarea"
              :rows="12"
              v-model="scanBarcodeIn"
            ></el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="warehousingVisible = false">取 消</el-button>
            <!-- <el-button type="primary" @click="submitScanInData">确 定</el-button> -->
          </span>
        </el-dialog>
        <el-dialog :visible.sync="showPreview" width="60%">
          <img :src="picPreview" alt="Preview" style="width: 100%" />
          <div slot="footer" class="dialog-footer">
            <el-button @click="retakePhoto">重拍</el-button>
            <el-button type="primary" @click="showPreview = false"
              >取消</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { textPrintData } from "@/utils/printData/Text";
import { batchPrintData } from "@/utils/printData/Batch";
import { client } from "@/utils/alioss.js";
// import VueRotate from 'vue-rotate'
// import { barcodePrintData } from "@/utils/printData/Barcode";
export default {
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      showPreview: false,
      picPreview: "",
      picList: [],
      SupplierList: [],
      toprintVisible: false,
      addNPVisible: false,
      formLabelWidth: "100px",
      rotation: 0, // 旋转的角度
      isScreenValid: true, // 标记输入字段是否有效
      usernameError: "", // 存放错误消息
      rules: {
        IsLock: [
          { required: true, message: "请选择是否有锁", trigger: "change" },
        ],
        phoneType: [
          { required: true, message: "请选择机器类型", trigger: "change" },
        ],
        phoneVersion: [
          { required: true, message: "请选择机器版本", trigger: "change" },
        ],
        salesGuarantee: [
          { required: true, message: "请选择售后保障", trigger: "change" },
        ],
        phoneBrand: [
          { required: true, message: "请选择手机品牌", trigger: "change" },
        ],
        phoneName: [
          { required: true, message: "请选择手机型号", trigger: "change" },
        ],
        phoneColor: [
          { required: true, message: "请选择手机颜色", trigger: "change" },
        ],
        phoneMemory: [
          { required: true, message: "请选择手机内存", trigger: "change" },
        ],
        phoneOldList: [
          { required: true, message: "请选择手机成色", trigger: "change" },
        ],
        Tips: [
          { required: true, message: "请选择屏电情况", trigger: "change" },
        ],
        phoneOld: [
          { required: true, message: "请选择成色", trigger: "change" },
        ],
        SNName: [{ required: true, message: "请输入序列号", trigger: "blur" }],
        phoneElectricityList: [
          { required: true, message: "请输入电池健康度", trigger: "blur" },
        ],
        modelName: [
          { required: true, message: "请输入型号号码", trigger: "blur" },
        ],
        IMEIName: [
          { required: true, message: "请输入IMEI码", trigger: "blur" },
        ],
        Supplier: [
          { required: true, message: "请选择供应商", trigger: "change" },
        ],
      },
      barCodeNum: "",
      phoneBrandList: [],
      phoneNameList: [],
      phoneColorList: [],
      phoneMemoryList: [],
      phoneRuningMemoryList: [],
      phoneGuaranteeList: ["店保", "第三方保修", "官保"],
      phoneVersionList: ["国行", "美版", "欧版", "港版", "日版", "其它版本"],
      phoneTypeList: [
        "零售机",
        "资源机",
        "权益机",
        "演示机",
        "官换机",
        "官翻机",
        "卡贴机",
        "其他类型",
      ],
      phoneOldList: ["99新", "95新", "9成新", "8成新"],
      TipsList: ["原屏原电", "换屏换电", "原屏换电", "换屏原电"],
      phoneForm: {},
      warehousingVisible: false,
      scanBarcodeIn: "",
      jsonObj,
      printVisible: false,
      cropperVisible: false,
      cropperLoading: false,
      previewImg: "",
      isPreview: false,
      // 打印服务是否连接成功
      printSocketOpen: false,
      textPrintData,
      // barcodePrintData,
      batchPrintData,
      barCodeList: [],
      barCodePrintList: [],
      barcodePrintFlag: false,
      nMPrintSocket: null,
      usbPrinters: {},
      usbSelectPrinter: "",
      onlineUsbBool: false,
      initBool: false,
      recognizedText: [],
      SNflag: true,
      IMEIflag: true,
      batteryflag: true,
      screenflag: true,
      backflag: true,
      leftflag: true,
      rightflag: true,
      topflag: true,
      bottomflag: true,
      SNData: {},
      IMEIData: {},
      batteryData: {},
      screenData: {},
      backData: {},
      leftData: {},
      rightData: {},
      topData: {},
      bottomData: {},
      density: 3,
      label_type: 1,
      print_mode: 1,
      picText: "",
      photoDataUrl: null,
      crooperedPic: "",
      crooperoption: {
        canMove: false,
        zoomable: false,
        canMoveBox: true,
        autoCrop: true,
        img: "", // 裁剪图片的地址
        centerBox: true, // 截图框是否被限制在图片里面
      },
      SNoptions: [{ value: "序列号", label: "序列号" }],
      IMEIoptions: [{ value: "IMEI码", label: "IMEI码" }],
      batteryOptions: [{ value: "电池容量", label: "电池容量" }],
      screenOptions: [
        { value: "完好", label: "完好" },
        { value: "使用痕迹", label: "使用痕迹" },
        { value: "划痕", label: "划痕" },
        { value: "磕碰", label: "磕碰" },
      ],
      backOptions: [
        { value: "背板完好", label: "背板完好" },
        { value: "背板磕碰", label: "背板磕碰" },
        { value: "摄像头完好", label: "摄像头完好" },
        { value: "背板使用痕迹", label: "背板使用痕迹" },
        { value: "背板划痕", label: "背板划痕" },
        { value: "摄像头磨损", label: "摄像头磨损" },
        { value: "摄像头使用痕迹", label: "摄像头使用痕迹" },
        { value: "摄像头磕碰", label: "摄像头磕碰" },
      ],
      value: "",
      userId:"1940694",
    };
  },
  computed: {
    imageStyle() {
      return {
        transform: `rotate(${this.rotation}deg)`,
      };
    },
  },
  mounted() {
    this.startCamera();
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.obtainPhoneInfo();
    this.obtainSupplierInfo();
    this.SNData.picText = this.SNoptions[0].value;
    this.IMEIData.picText = this.IMEIoptions[0].value;
    this.batteryData.picText = this.batteryOptions[0].value;
    this.login();
  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if(userId != null || userId != undefined){
        this.userId = userId;
      }
      console.log("userid:",this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
            this.obtainPhoneInfo();
            this.obtainSupplierInfo();
          }else{
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    queryPhoneColorList() {
      console.log(this.phoneForm.phoneName, "选择型号");
      // 创建一个新的 Axios 实例专用于 /colorListApi 请求
      const colorListApiInstance = axios.create({
        baseURL: "/colorListApi",
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        // }
      });
      //使用FormData对象发送POST请求
      colorListApiInstance
        .post(
          "monkeyshop/common/searchPhoneColorByModel" +
            "?" +
            "modelName" +
            "=" +
            this.phoneForm.phoneName +"&userId=" +
            this.userId
        )
        .then((res) => {
          console.log(res, "res");
          this.phoneColorList = res.data.data.colors;
          // this.tableData = res.data.
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    retakePhoto() {
      console.log(this.reTakePhoneNum, "retakephoto");
      console.log("重拍");
      this.showPreview = false;
      if (this.reTakePhoneNum == 1) {
        this.screenData.url = "";
        this.screenflag = true;
      } else if (this.reTakePhoneNum == 2) {
        this.backData.url = "";
        this.backflag = true;
      } else if (this.reTakePhoneNum == 3) {
        this.leftData.url = "";
        this.leftflag = true;
      } else if (this.reTakePhoneNum == 4) {
        this.rightData.url = "";
        this.rightflag = true;
      } else if (this.reTakePhoneNum == 5) {
        this.topData.url = "";
        this.topflag = true;
      } else if (this.reTakePhoneNum == 6) {
        this.bottomData.url = "";
        this.bottomflag = true;
      } else if (this.reTakePhoneNum == 7) {
        this.SNData.url = "";
        this.SNflag = true;
      } else if (this.reTakePhoneNum == 8) {
        this.IMEIData.url = "";
        this.IMEIflag = true;
      } else if (this.reTakePhoneNum == 9) {
        this.batteryData.url = "";
        this.batteryflag = true;
      }
    },
    handleLarge(val, photoNum) {
      console.log(val, photoNum, "handlelarge");
      this.picPreview = val;
      this.reTakePhoneNum = photoNum;
      this.showPreview = true;
    },
    async print(content) {
      // console.log(content)
      content.elements[1].json.value = "型号：" + this.phoneForm.phoneName;
      content.elements[2].json.value = "内存：" + this.phoneForm.phoneMemory;
      content.elements[3].json.value =
        "电池健康度：" + this.phoneForm.phoneElectricityList;
      content.elements[4].json.value = "手机品牌：" + this.phoneForm.phoneBrand;
      content.elements[5].json.value = "颜色：" + this.phoneForm.phoneColor;
      content.elements[6].json.value = "成色：" + this.phoneForm.phoneOld;
      content.elements[7].json.value = "屏电情况：" + this.phoneForm.Tips;
      content.elements[8].json.value = "序列号：" + this.phoneForm.SNName;
      // content.elements[8].json.value = this.phoneForm.SNName
      const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
      console.log(allPrintersRes, "allPrintersRes");
      try {
        // const { errorCode, info } = JSON.parse(JSON.stringify(data)).resultAck;
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          const allPrintersName = Object.keys(allPrinters);
          const allPrintersValue = Object.values(allPrinters);
          console.log(allPrinters, "allPrinters");
          console.log(
            allPrintersName[0],
            allPrintersValue[0],
            "allPrintersName[0]",
            "allPrinters[0]"
          );
          const res = await this.nMPrintSocket.selectPrinter(
            allPrintersName[0],
            parseInt(allPrintersValue[0])
          );
          console.log("选择打印机", res);

          if (res.resultAck.errorCode === 0) {
            console.log("连接成功");
            const initRes = await this.nMPrintSocket.initSdk({ fontDir: "" });
            if (initRes.resultAck.errorCode == 0) {
              console.log("初始化成功");
              this.startPrintJobTest(content);
            } else {
              console.log("初始化失败");
            }
          } else {
            console.log("连接失败");
            alert("连接失败");
          }
        } else {
          return alert("没有在线的打印机");
        }
      } catch (err) {
        return alert(err);
      }
    },
    submit() {
      this.toprintVisible = true;
    },
    handleClose() {
      this.addNPVisible = false;
      this.$refs.phoneForm.resetFields();
      this.phoneForm = {};
    },
    beforeAvatarUpload(file) {
      console.log(file, "beforeAvatarUploadfile");
      return;
    },
    //更新打印机列表
    async getPrinters() {
      console.log(this.nMPrintSocket, "更新打印机列表");
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      console.log("开始获取打印机");
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          console.log("printers", this.usbPrinters);
        } else {
          alert("没有在线的打印机");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 连接打印机
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      console.log("开始连接打印机");
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    //打印预览
    async previewTest(content) {
      console.log(this.phoneForm, "------------phoneForm-----------");
      console.log(content, "----------previewContent--------");
      console.log(this.textPrintData, "----------this.textPrintData.--------");
      console.log(
        this.textPrintData.elements[1].json.value,
        "----------textPrintData--------"
      );
      this.textPrintData.elements[1].json.value =
        "手机品牌：" + this.phoneForm.phoneBrand;
      this.textPrintData.elements[2].json.value =
        "型号：" + this.phoneForm.phoneName;
      this.textPrintData.elements[3].json.value =
        "颜色：" + this.phoneForm.phoneColor;
      this.textPrintData.elements[4].json.value =
        "内存：" + this.phoneForm.phoneMemory;
      this.textPrintData.elements[5].json.value =
        "电量：" + this.phoneForm.phoneElectricityList;
      this.textPrintData.elements[6].json.value =
        "成色：" + this.phoneForm.phoneOld;
      this.textPrintData.elements[7].json.value =
        "屏电情况：" + this.phoneForm.Tips;
      this.textPrintData.elements[8].json.value = this.phoneForm.SNName;
      console.log(this.textPrintData, "------------修改后的数据------------");
      if (!this.printSocketOpen) return alert("打印服务未开启");
      let contentArr = [];
      contentArr.push(this.textPrintData);
      this.printTag(contentArr, 0, true);
      this.printVisible = true;
    },
    // 开始打印
    async startPrintJobTest(content) {
      // console.log(content,'----------打印内容-------------')
      // console.log(this.textPrintData,'----------textPrintData打印内容-------------')
      if (!this.printSocketOpen) return alert("打印服务未开启");
      let contentArr = [];
      contentArr.push(content);
      this.batchPrintJob(contentArr);
    },
    // 开始批量打印
    async startBatchPrintJobTest(content) {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      this.batchPrintJob(content.data);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x, isPreview) {
      console.log(list, x, isPreview, "绘制打印标签isPreview");
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0, isPreview);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i, isPreview) {
      console.log(isPreview, "printItem isPreview");
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
          }
        } else {
          console.log(isPreview, "isPreview我到这里了");
          if (isPreview) {
            console.log(isPreview, "isPreview我到这里了");
            // const res = this.nMPrintSocket.generateImagePreviewImage(8)
            // console.log(res, "generateImagePreviewImageRes");
            const res = await this.nMPrintSocket.generateImagePreviewImage(8);
            console.log(res, "----------preImgRes---------");
            //预览图生成失败退出流程
            if (res.resultAck.result != 0) {
              return;
            }
            this.previewImg =
              "data:image/jpeg;base64," +
              JSON.parse(res.resultAck.info).ImageData;
            console.log(this.previewImg, "this.previewImg请求成功");
          }
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          if (
            commitRes.resultAck.printQuantity == list.length &&
            commitRes.resultAck.onPrintPageCompleted ==
              this.jsonObj.printerImageProcessingInfo.printQuantity
          ) {
            //结束打印任务
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
              this.submitData();
              this.printVisible = false;
              // socketData.close()
            }
            return;
          }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据
          if (commitRes.resultAck.errorCode === 0 && x < list.length - 1) {
            //数据提交成功，数据下标+1
            console.log("发送下一页打印数据： ");
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    startCamera() {
      const video = this.$refs.videoElement;
      navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
        video.srcObject = stream;
        // 当视频加载完成时开始获取画布上的图片数据
        video.onloadedmetadata = () => {
          video.play();
          // 每次视频元素更新都会重新生成canvas并将其转换为图片数据URL
          setInterval(() => {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = video.clientWidth;
            canvas.height = video.clientHeight;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            this.photoDataUrl = canvas.toDataURL();
          }, 1000);
        };
      });
    },
    onCropperReady() {
      // 当cropper准备好后，可以自动旋转图片
      this.$refs.cropper.rotate(90); // 旋转90度
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    takePhoto() {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let video = this.$refs.videoElement;

      // 设置 canvas 的尺寸为 video 的尺寸
      canvas.width = video.videoHeight; // 注意：宽高颠倒，因为视频被旋转了90度
      canvas.height = video.videoWidth;

      // 将视频帧绘制到 canvas 上，应用旋转
      // 注意：因为视频旋转了90度，所以绘制时需要调整
      context.translate(canvas.width / 2, canvas.height / 2); // 将旋转中心移动到 canvas 中心
      context.rotate((90 * Math.PI) / 180); // 旋转90度
      context.drawImage(video, -video.videoWidth / 2, -video.videoHeight / 2); // 绘制视频帧

      // 从 canvas 上获取图片数据
      this.photoDataUrl = canvas.toDataURL("image/png");
      if (this.photoDataUrl) {
        this.crooperoption.img = this.photoDataUrl;
        this.cropperVisible = true;

        console.log(this.crooperoption.img);
        // this.roRight()
        console.log("已经拍了照");

        // 这里可以对拍摄到的图片进行处理或保存等操作
      } else {
        console.error("还没有拍照");
      }
      // this.$refs.cropper.rotateRight()
    },
    startPrintBarcode() {
      this.barcodePrintFlag = true;
    },
    handleChange(val) {
      if (this.screenData.url) {
        this.screenData.picText = val;
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleChangeBack(val) {
      if (this.backData.url) {
        this.backData.picText = val;
        // this.picList.push(this.backData)
      }
    },
    handleChangeLeft(val) {
      if (this.leftData.url) {
        this.leftData.picText = val;
        // this.picList.push(this.leftData)
      }
    },
    handleChangeRight(val) {
      if (this.rightData.url) {
        this.rightData.picText = val;
        // this.picList.push(this.rightData)
      }
    },
    handleChangeTop(val) {
      if (this.topData.url) {
        this.topData.picText = val;
        // this.picList.push(this.topData)
      }
    },
    handleChangeBottom(val) {
      if (this.bottomData.url) {
        this.bottomData.picText = val;
        // this.picList.push(this.bottomData)
      }
      // console.log(this.picList,'piclist')
    },

    confirmPic() {
      // 创建一个新的 Axios 实例专用于 /OCRApi 请求
      const ocrApiInstance = axios.create({
        baseURL: "/OCRApi",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      this.$refs.cropper.getCropBlob((data) => {
        console.log(data, "data");
        if (this.screenflag) {
          //定义唯一的文件名
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.screenData, "url", result.url);
              this.screenflag = false;
            });
          this.screenData.name = "屏幕";
        } else if (this.backflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.backData, "url", result.url);
              console.log(this.backData.url, "backData.url");
              this.backflag = false;
            });
          this.backData.name = "背板";
        } else if (this.leftflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.leftData, "url", result.url);
              console.log(this.leftData.url, "leftData.url");
              this.leftflag = false;
            });
          this.leftData.name = "左侧面";
        } else if (this.rightflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.rightData, "url", result.url);
              console.log(this.rightData.url, "rightData.url");
              this.rightflag = false;
            });
          this.rightData.name = "右侧面";
        } else if (this.topflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.topData, "url", result.url);
              console.log(this.topData.url, "topData.url");
              this.topflag = false;
            });
          this.topData.name = "上面";
        } else if (this.bottomflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.bottomData, "url", result.url);
              console.log(this.bottomData.url, "bottomData.url");
              this.bottomflag = false;
            });
          this.bottomData.name = "尾插面";
        } else if (this.SNflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.SNData, "url", result.url);
              this.SNData.url = result.url;
              const imageData = data;
              // 创建一个FormData对象
              const formData = new FormData();
              formData.append("file", imageData, this.SNData.name);
              // formData.append('age', 30);
              var that = this;
              //使用FormData对象发送POST请求
              ocrApiInstance
                .post("monkeyshop/ocr/orcString", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                  // baseURL: '/OCRApi'
                })
                .then((res) => {
                  that.$set(that.phoneForm, "phoneName", res.data.phoneName);
                  that.$set(that.phoneForm, "modelName", res.data.modelName);
                  that.$set(that.phoneForm, "SNName", res.data.snname);
                  that.$set(
                    that.phoneForm,
                    "phoneMemory",
                    res.data.phoneMemory
                  );
                  console.log(res, "SNData");
                  this.SNflag = false;
                })
                .catch(function (error) {
                  console.log(error);
                });
              console.log(this.SNData.url, "SNData.url");
            });
          this.SNData.name = "SN码";
          this.SNData.picText = this.SNData.picText;
        } else if (this.IMEIflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.IMEIData, "url", result.url);
              const imageData = data;
              // 创建一个FormData对象
              const formData = new FormData();
              formData.append("file", imageData, this.IMEIData.name);
              // formData.append('age', 30);
              var that = this;
              //使用FormData对象发送POST请求
              ocrApiInstance
                .post("monkeyshop/ocr/orcString", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                  // baseURL: '/OCRApi'
                })
                .then((res) => {
                  that.$set(that.phoneForm, "IMEIName", res.data.imeiname);
                  that.$set(that.phoneForm, "IMEI2Name", res.data.imei2Name);
                  console.log(res, "IMEIData");
                  this.IMEIflag = false;
                })
                .catch(function (error) {
                  console.log(error);
                });
              console.log(this.IMEIData.url, "IMEIData.url");
            });
          this.IMEIData.name = "IMEI码";
          this.IMEIData.picText = this.IMEIData.picText;
          this.IMEIData.picBlob = data;
          this.picList.push(this.IMEIData);
        } else if (this.batteryflag) {
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.batteryData, "url", result.url);
              const imageData = data;
              // 创建一个FormData对象
              const formData = new FormData();
              formData.append("file", imageData, this.batteryData.name);
              // formData.append('age', 30);
              var that = this;
              //使用FormData对象发送POST请求
              ocrApiInstance
                .post("monkeyshop/ocr/orcString", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                  // baseURL: '/OCRApi'
                })
                .then((res) => {
                  that.$set(
                    that.phoneForm,
                    "phoneElectricityList",
                    res.data.phoneElectricityList
                  );

                  // that.phoneForm.phoneElectricityList = res.data.phoneElectricityList
                  console.log(res, "batteryData");
                  this.batteryflag = false;
                })
                .catch(function (error) {
                  console.log(error);
                });
              console.log(this.batteryData.url, "batteryData.url");
            });
          this.batteryData.name = "电池容量";
          this.batteryData.picText = this.batteryData.picText;
          this.batteryData.picBlob = data;
          this.picList.push(this.batteryData);
        }
        this.crooperoption.img = null;
        this.cropperVisible = false;
      });
    },
    toWarehousing() {
      this.warehousingVisible = true;
    },
    submitScanInData() {
      console.log(this.scanBarcodeIn, "-------scanBarcodeIn---------");
      const oneBarcodeIn = this.scanBarcodeIn.split("\n");
      console.log(oneBarcodeIn, "----------oneBarcodeIn---------");
    },
    obtainPhoneInfo() {
      this.phoneBrandList = [];
      this.phoneNameList = [];
      // this.phoneColorList = []
      this.phoneMemoryList = [];
      this.phoneRuningMemoryList = [];
      axios({
        method: "post",
        url: "/openApi/app/5u91so0k1801/apply/filter",
        data: {
          pageSize: 99999,
          pageNum: 1,
          queries: [
            {
              queId: 182383141,
              searchKey: element,
            },
          ],
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          res.data.result.result.forEach((element) => {
            element.answers.forEach((item) => {
              if (item.queId == "182383247") {
                this.phoneNameList.push(item.values[0].dataValue);
              }
              // if(item.queId == '182383248'){
              //   this.phoneColorList.push(item.values[0].dataValue)
              // }
              if (item.queId == "182383250") {
                this.phoneMemoryList.push(item.values[0].dataValue);
              }
              if (item.queId == "182392814") {
                this.phoneBrandList.push(item.values[0].dataValue);
              }
              if (item.queId == "182383249") {
                this.phoneRuningMemoryList.push(item.values[0].dataValue);
              }
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtainSupplierInfo() {
      this.SupplierList = [];
      axios({
        method: "post",
        url: "/openApi/app//6kfr38eo2s01/apply/filter",
        data: {
          pageSize: 50,
          pageNum: 1,
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          console.log(res, "供应商");
          res.data.result.result.forEach((element) => {
            element.answers.forEach((item) => {
              if (item.queId == "182393742") {
                this.SupplierList.push(item.values[0].dataValue);
              }
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitData() {
      var that = this;
      this.$refs.phoneForm.validate((valid) => {
        console.log(valid, "valid");
        if (valid) {
          console.log(that.SNData, "SNData");
          console.log(that.IMEIData, "IMEIData");
          console.log(that.batteryData, "batteryData");
          console.log(that.screenData, "screenData");
          console.log(that.backData, "backData");
          console.log(that.leftData, "leftData");
          console.log(that.rightData, "rightData");
          console.log(that.topData, "topData");
          console.log(that.bottomData, "bottomData");
          console.log(that.phoneForm, "phoneForm");
          axios({
            method: "post",
            url: "/openApi/app/5u91so0c1801/apply",
            data: {
              applyUser: {
                email: "",
              },
              answers: [
                {
                  queId: 182392813,
                  queTitle: "手机分类",
                  queType: 10,
                  values: [
                    {
                      value: "二手机",
                    },
                  ],
                },
                {
                  queId: 182392815,
                  queTitle: "手机品牌",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneBrand,
                    },
                  ],
                },
                {
                  queId: 182383149,
                  queTitle: "机型名称",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneName,
                    },
                  ],
                },
                {
                  queId: 182392817,
                  queTitle: "是否有锁",
                  queType: 10,
                  values: [
                    {
                      value: that.phoneForm.IsLock,
                    },
                  ],
                },
                {
                  queId: 182392816,
                  queTitle: "机器类型",
                  queType: 11,
                  values: [
                    {
                      value: that.phoneForm.phoneType,
                    },
                  ],
                },
                {
                  queId: 182392818,
                  queTitle: "机器版本",
                  queType: 11,
                  values: [
                    {
                      value: that.phoneForm.phoneVersion,
                    },
                  ],
                },
                {
                  queId: 182392819,
                  queTitle: "售后保障",
                  queType: 11,
                  values: [
                    {
                      value: that.phoneForm.salesGuarantee,
                    },
                  ],
                },
                {
                  queId: 182383143,
                  queTitle: "手机颜色",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneColor,
                    },
                  ],
                },
                {
                  queId: 182383145,
                  queTitle: "内存",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneMemory,
                    },
                  ],
                },
                {
                  queId: 182383144,
                  queTitle: "运行内存",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.phoneRuningMemoryList,
                    },
                  ],
                },
                {
                  queId: 182383175,
                  queTitle: "电池健康程度（%）",
                  queType: 2,
                  values: [
                    {
                      value: that.phoneForm.phoneElectricityList,
                    },
                  ],
                },
                {
                  queId: 182390624,
                  queTitle: "成色",
                  queType: 2,
                  values: [
                    {
                      value: that.phoneForm.phoneOld,
                    },
                  ],
                },
                {
                  queId: 182394355,
                  queTitle: "屏电情况",
                  queType: 11,
                  values: [
                    {
                      value: that.phoneForm.Tips,
                    },
                  ],
                },
                {
                  queId: 182394289,
                  queTitle: "供应商名称",
                  queType: 19,
                  values: [
                    {
                      value: that.phoneForm.Supplier,
                    },
                  ],
                },
                {
                  queId: 182383141,
                  queTitle: "SN码",
                  queType: 2,
                  values: [
                    {
                      value: that.phoneForm.SNName,
                    },
                  ],
                },
                {
                  queId: 182390634,
                  queTitle: "型号号码",
                  queType: 2,
                  values: [
                    {
                      value: that.phoneForm.modelName,
                    },
                  ],
                },
                {
                  queId: 182383142,
                  queTitle: "IMEI码",
                  queType: 2,
                  values: [
                    {
                      value: that.phoneForm.IMEIName,
                    },
                  ],
                },
                {
                  queId: 182390623,
                  queTitle: "IMEI2",
                  queType: 2,
                  values: [
                    {
                      value: that.phoneForm.IMEI2Name,
                    },
                  ],
                },
                {
                  queId: 182390625,
                  queTitle: "序列号图片",
                  queType: 13,
                  values: [
                    {
                      value: that.SNData.url,
                    },
                  ],
                },
                {
                  queId: 182390626,
                  queTitle: "IMEI码图片",
                  queType: 13,
                  values: [
                    {
                      value: that.IMEIData.url,
                    },
                  ],
                },
                {
                  queId: 182390627,
                  queTitle: "电池容量图片",
                  queType: 13,
                  values: [
                    {
                      value: that.batteryData.url,
                    },
                  ],
                },
                {
                  queId: 182390628,
                  queTitle: "手机正面图",
                  queType: 13,
                  values: [
                    {
                      value: that.screenData.url,
                    },
                  ],
                },
                {
                  queId: 182390637,
                  queTitle: "手机正面图备注",
                  queType: 2,
                  values: [
                    {
                      value: that.screenData.picText,
                    },
                  ],
                },
                {
                  queId: 182390629,
                  queTitle: "手机背面图",
                  queType: 13,
                  values: [
                    {
                      value: that.backData.url,
                    },
                  ],
                },
                {
                  queId: 182390638,
                  queTitle: "手机背面图备注",
                  queType: 2,
                  values: [
                    {
                      value: that.backData.picText,
                    },
                  ],
                },
                {
                  queId: 182390630,
                  queTitle: "手机左侧面图",
                  queType: 13,
                  values: [
                    {
                      value: that.leftData.url,
                    },
                  ],
                },
                {
                  queId: 182390639,
                  queTitle: "手机左侧面图备注",
                  queType: 2,
                  values: [
                    {
                      value: that.leftData.picText,
                    },
                  ],
                },
                {
                  queId: 182390631,
                  queTitle: "手机右侧面图",
                  queType: 13,
                  values: [
                    {
                      value: that.rightData.url,
                    },
                  ],
                },
                {
                  queId: 182390640,
                  queTitle: "手机右侧面图备注",
                  queType: 2,
                  values: [
                    {
                      value: that.rightData.picText,
                    },
                  ],
                },
                {
                  queId: 182390632,
                  queTitle: "手机顶部图",
                  queType: 13,
                  values: [
                    {
                      value: that.topData.url,
                    },
                  ],
                },
                {
                  queId: 182390641,
                  queTitle: "手机顶部图备注",
                  queType: 2,
                  values: [
                    {
                      value: that.topData.picText,
                    },
                  ],
                },
                {
                  queId: 182390633,
                  queTitle: "手机尾插图",
                  queType: 13,
                  values: [
                    {
                      value: that.bottomData.url,
                    },
                  ],
                },
                {
                  queId: 182390642,
                  queTitle: "手机尾插图备注",
                  queType: 2,
                  values: [
                    {
                      value: that.bottomData.picText,
                    },
                  ],
                },
                {
                  queId: 182383150,
                  queTitle: "数据状态（请勿修改）",
                  queType: 10,
                  values: [
                    {
                      value: "在库",
                    },
                  ],
                },
              ],
            },
            headers: {
              accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
              "Content-Type": "application/json",
            },
          })
            .then((res) => {
              console.log(res, "res");
              this.$message({
                message: "手机入库成功",
                type: "success",
              });
              this.SNData = {};
              this.IMEIData = {};
              this.batteryData = {};
              this.screenData = {};
              this.backData = {};
              this.leftData = {};
              this.rightData = {};
              this.topData = {};
              this.bottomData = {};
              this.phoneForm = {};
              this.SNflag = true;
              this.IMEIflag = true;
              this.batteryflag = true;
              this.screenflag = true;
              this.backflag = true;
              this.leftflag = true;
              this.rightflag = true;
              this.topflag = true;
              this.bottomflag = true;

              this.$nextTick(() => {
                this.$refs["phoneForm"].clearValidate();
              });
              this.$forceUpdate();
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
/* .input{
  width: ;
} */
.top-container {
  height: 900px;
  flex-direction: wrap;
  display: flex;
  width: 100%;
}
.left-container {
  width: 50%;
  margin: 25px;
  background-color: #d9ecff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center; /* 子元素水平居中对齐 */
  justify-content: flex-start; /* 从顶部开始排列子元素 */
}
.first-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.bottom-container {
  height: 650px;
  /* width: 100%; */
  background-color: #d9ecff;
  flex-direction: wrap;
  display: flex;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
}
.middle-container {
  /* width: 100%; */
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
  background-color: #d9ecff;
}
.bottom-left-container {
  width: 48%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
  background-color: #d9ecff;
  display: flex;
  flex-direction: column;
}
.bottom-right-container {
  /* width: 48%; */
  margin: 25px;
  padding: 2%;
  /* margin: 0px 25px 0px 25px; */
  background-color: #d9ecff;
  border-radius: 20px;
}
.right-container {
  width: 50%;
  background-color: #d9ecff;
  margin: 25px;
  height: auto;
  border-radius: 20px;
}
.img-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 50px 0px 50px;
  /* gap: 15px; */
  /* justify-content: center; */
}
.img-item-container {
  width: 26%;
  height: 240px;
  margin-bottom: 20px;
  /* background-color: #E4E7ED; */
  /* display: flex; */
}
.cropper {
  width: auto;
  height: 400px;
}
h3 {
  text-align: left;
}
.content {
  /* border: solid 1px #ced4da; */
  padding: 8px;
  text-align: left;
}
.print_container {
  width: 100%;
  height: 40%;
}
.barcode_printing_container {
  width: 100%;
  height: 60%;
  background-color: #d9ecff;
}
.single-image {
  background-color: #e4e7ed;
  height: 200px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  line-height: 195px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.video-container {
  /* position: relative; */
  /* width: 100%;  */
  height: 500px; /* 或者指定高度 */
  overflow: hidden; /* 隐藏超出容器部分 */
  width: 100%; /* 根据需要调整宽度 */
  margin-top: 20px; /* 与按钮保持一定距离 */
}
#video {
  transform: rotate(90deg);
  width: 100%;
  /* 调整宽高以适应容器 */
  height: auto; /* 高度自适应，保持比例 */
}
</style>


// WEBPACK FOOTER //
// src/views/picRecongnition.vue